"use strict";
/**
 * Utility rate-plan model.
 *
 * The shape here is deliberately market-agnostic rather than California-specific, because the
 * fleet will not stay in one state. Three seams carry that weight:
 *
 * - `Utility.market` — regulated territories resolve zip → utility → plan. Deregulated ones
 *   (TX, OH, parts of PA/IL/NY) cannot: the customer buys from a retail provider they chose, so
 *   no utility default rate exists to look up. Dispatching on this field means adding those
 *   states later is a new strategy behind an existing interface, not a rewrite.
 * - `RatePlan.variantLabel` — SCE prices by "Baseline Region", a CPUC construct. Other utilities
 *   zone by climate zone, seasonal definition or heating type. Keeping the concept generic and
 *   the CA wording a mere label stops the schema from acquiring California's vocabulary.
 * - `RatePlan.serviceType` — a bill is not always one number. Where generation is unbundled from
 *   delivery, the two are priced separately and must be summed.
 *
 * Everything in this file is pure data description. No network calls, no runtime lookups: the
 * plan tables are committed so a quoted rate can always be traced to a dated source, and so the
 * tables can later be machine-generated without any consumer changing.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VARIANT = void 0;
/** Key used for plans whose pricing does not vary by territory. */
exports.DEFAULT_VARIANT = 'default';
